import { SendManualOffer, SendManualOfferNorlys } from '~src/components/SendManualOffer';
import { useDisplay } from '~src/hooks/useDisplay';
import { CustomerDetails, ResidenceInput } from '~src/model';

import { ModalBodil } from '../bodil';
import { ModalNorlys } from '../norlys';
import { ModalProps } from '../types';

export type SendOfferModalProps = ModalProps & {
  isLoading?: boolean;
  onConfirm: (parameters: Partial<CustomerDetails>) => void;
  closable?: boolean;
  residence?: Partial<Omit<ResidenceInput, 'address'>>;
};

export const SendOfferModal = ({
  residence,
  visible,
  setVisible,
  onConfirm,
  isLoading,
  closable = false,
}: SendOfferModalProps) => {
  const { isMobile } = useDisplay();

  return (
    <ModalBodil
      {...{
        width: isMobile ? '100%' : '60%',
        title: '',
        visible,
        setVisible,
        closable,
      }}
    >
      <SendManualOffer isLoading={isLoading} onConfirm={onConfirm} residence={residence} />
    </ModalBodil>
  );
};

export const SendOfferModalNorlys = ({ visible, setVisible, onConfirm, isLoading }: SendOfferModalProps) => {
  const { isMobile } = useDisplay();

  return (
    <ModalNorlys
      {...{
        styles: { header: { borderRadius: 0 } },
        bodyStyle: {
          paddingTop: 0,
          borderRadius: 0,
        },
        width: isMobile ? '100%' : '60%',
        title: '',
        visible,
        setVisible,
        closable: !!setVisible,
      }}
    >
      <SendManualOfferNorlys isLoading={isLoading} onConfirm={onConfirm} />
    </ModalNorlys>
  );
};
